import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/index.css';
import App from './app/App';
import React from 'react';

const el = document.getElementById('root');
if (!el) throw new Error('Root element #root not found');

const root = createRoot(el);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
